import { PanelAlert } from './PanelAlert';
import { PanelCard } from './PanelCard';
import { PanelGrid } from './PanelGrid';
import { PanelHeader } from './PanelHeader';
import { PanelRoot } from './PanelRoot';
import { PanelSection } from './PanelSection';
import { PanelStatusBadge } from './PanelStatusBadge';
import { PanelTabs } from './PanelTabs';
import { PanelTile } from './PanelTile';

export const Panel = Object.assign(PanelRoot, {
  Alert: PanelAlert,
  Card: PanelCard,
  Grid: PanelGrid,
  Header: PanelHeader,
  Section: PanelSection,
  StatusBadge: PanelStatusBadge,
  Tabs: PanelTabs,
  Tile: PanelTile,
});

export type { PanelGridColumns, PanelIntent } from './Panel.types';
export type { PanelAlertProps } from './PanelAlert';
export { PanelAlert } from './PanelAlert';
export type { PanelCardProps } from './PanelCard';
export { PanelCard } from './PanelCard';
export type { PanelGridProps } from './PanelGrid';
export { PanelGrid } from './PanelGrid';
export type { PanelHeaderProps } from './PanelHeader';
export { PanelHeader } from './PanelHeader';
export type { PanelRootProps } from './PanelRoot';
export { PanelRoot } from './PanelRoot';
export type { PanelSectionProps } from './PanelSection';
export { PanelSection } from './PanelSection';
export type { PanelStatusBadgeProps } from './PanelStatusBadge';
export { PanelStatusBadge } from './PanelStatusBadge';
export type { PanelTabItem, PanelTabsProps } from './PanelTabs';
export { PanelTabs } from './PanelTabs';
export type { PanelTileProps } from './PanelTile';
export { PanelTile } from './PanelTile';
